import * as filterActions from '@common/Filters/actions/actionTypes';
import { getActiveFiltersFromUrlQuery } from '@common/Filters/helpers';
import { getQueryFromFilters } from '../helpers/filters';
import { updateProductsCounter } from '../helpers/legacyCode';
import * as listingActions from './actionTypes';

const getSelectedLimit = (stateLimit) => {
    const limitPairsArray = Object.entries(stateLimit);
    let selectedLimit = 120;

    if (limitPairsArray.length > 0) {
        for (const [limit, selected] of limitPairsArray) {
            if (selected) {
                selectedLimit = limit;
                break;
            }
        }
    }

    return selectedLimit;
};

export const setQuery = page => (dispatch, getState) => {
    const queryToSet = getQueryFromFilters(getState(), page);

    dispatch({
        payload: queryToSet,
        type: listingActions.SET_QUERY
    });
};

export const setSeoData = seoData => ({
    type: listingActions.SET_SEO_DATA,
    payload: seoData
});

export const setQueryFromUrl = query => (dispatch, getState) => {
    const { dropdownFilters } = getState().filters;
    const activeFilters = getActiveFiltersFromUrlQuery(query, dropdownFilters);

    dispatch({
        payload: query,
        type: listingActions.SET_QUERY
    });

    dispatch({
        type: filterActions.SET_ACTIVE_FILTERS,
        payload: activeFilters
    });
};

export const fetchProducts = page => (dispatch) => {
    dispatch(setQuery(page));
    return { type: listingActions.FETCH_PRODUCTS };
};

export const storeLimit = pageLimit => (dispatch, getState) => {
    const myPageLimit = pageLimit.reduce((acc, limit) => {
        acc[limit] = limit === getSelectedLimit(getState().listing.limit);
        return acc;
    }, {});

    dispatch({
        type: listingActions.STORE_LIMIT,
        payload: myPageLimit
    });
};

export const selectLimit = limit => (dispatch) => {
    dispatch({
        type: listingActions.SELECT_LIMIT,
        payload: limit
    });

    dispatch(fetchProducts());
};

export const selectGrid = grid => (dispatch) => {
    dispatch({
        type: listingActions.SELECT_GRID,
        payload: grid
    });

    dispatch(fetchProducts());
};

export const updateProductsCount = count => (dispatch) => {
    updateProductsCounter(count);

    dispatch({
        type: listingActions.UPDATE_PRODUCTS_COUNT,
        payload: count
    });
};

export const setProducts = products => dispatch => dispatch({
    type: listingActions.SET_PRODUCTS,
    payload: products
});

export const setOverlay = state => dispatch => dispatch({
    type: listingActions.SET_OVERLAY,
    payload: state
});

export const addFilter = (id, type, item) => (dispatch) => {
    dispatch({
        type: listingActions.ADD_FILTER,
        payload: {
            filterId: id,
            filterType: type,
            filterItem: item
        }
    });
};

export const setFilters = filters => dispatch => dispatch({
    type: listingActions.SET_SELECTED_FILTERS,
    payload: filters
});

export const setCurrentPage = page => dispatch => dispatch({
    type: listingActions.SET_CURRENT_PAGE,
    payload: page
});

export const setModelImageMode = value => (dispatch) => {
    dispatch({
        type: listingActions.SET_MODEL_IMAGE_MODE,
        payload: value
    });
};
